<!-- app/shared/components/dieuhanh/phanbo-chiphiedit.component.html -->
<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h3 class="text-primary">Phân bổ chi phí</h3>
      <hr>
    </div>
  </div>

  <!-- Form section -->
  <div class="" style="display: flex; align-items: center;">
    <div class="form-group">
      <label>Số tiền phân bổ:</label>
      <div class="input-group">
        <input type="text" class="form-control" [value]="soTienGoc | number" disabled>
        <div class="input-group-append">
          <span class="input-group-text" style="padding: 0px 10px;">đ</span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Từ tháng:</label>
      <kendo-datepicker [format]="'MM/yyyy'"
                        [(value)]="tuThang">
      </kendo-datepicker>
    </div>
    <div class="form-group">
      <label>Đến tháng:</label>
      <kendo-datepicker [format]="'MM/yyyy'"
                        [(value)]="denThang">
      </kendo-datepicker>
    </div>
    <button type="button" class="btn btn-primary" style="margin: 14px 0px 0px 10px;" (click)="phanBoChiPhi()">
      <i class="fa fa-calculator mr-1"></i> Phân bổ
    </button>
  </div>


  <!-- Table section -->
  <div class="row">
    <div class="col-12">
      <div style="display: flex; justify-content: space-between;">
        <h4>Danh sách chứng từ phân bổ</h4>
        <button type="button" class="btn btn-success" (click)="luuPhanBo()" [disabled]="!isProcessed || !isValid()">
          <i class="fa fa-save mr-1"></i> Lưu
        </button>
      </div>
      <table class="table table-bordered table-hover">
        <thead>
          <tr class="bg-light">
            <th style="width: 50px">#</th>
            <th>Ngày</th>
            <th>Số tiền</th>
            <th>Ghi chú</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="danhSachPhanBo.length === 0">
            <td colspan="4" class="text-center">Không có dữ liệu phân bổ</td>
          </tr>
          <tr *ngFor="let item of danhSachPhanBo; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.Ngay | date: 'dd/MM/yyyy' }}</td>
            <td class="text-right">
              <div class="input-group">
               
                <input class="form-control"
                       maxlength="20"
                       tabindex="6"
                       currencyMask
                       [(ngModel)]="item.SoTien"
                       name="value"
                       [placeholder]="'Số tiền'"
                       [options]="ngxCurrencyOptions" autocomplete="off" />
                <div class="input-group-append">
                  <span class="input-group-text">đ</span>
                </div>
              </div>
            </td>
            <td>
              <input type="text"
                     class="form-control"
                     [(ngModel)]="item.GhiChu"
                     placeholder="Ghi chú">
            </td>
          </tr>
        </tbody>
        <tfoot *ngIf="danhSachPhanBo.length > 0">
          <tr class="font-weight-bold">
            <td colspan="2" class="text-right">Tổng:</td>
            <td class="text-right">
              <span [ngClass]="{'text-danger': !isAmountBalanced(), 'text-success': isAmountBalanced()}">
                {{ getTongTien() | number }} đ
              </span>
              <div *ngIf="!isAmountBalanced()" class="small text-danger">
                Chênh lệch: {{ getDifference() | number }} đ
              </div>
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
